// GreenIQ brand mark — stylized concentric topographic rings + signal line.
// Inline SVG with a green glow filter so it reads as a lit beacon on dark nav.

export function BrandMark({ className = 'h-8 w-8' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="GreenIQ"
    >
      <defs>
        <clipPath id="giq-clip">
          <circle cx="32" cy="32" r="28" />
        </clipPath>
        <filter id="giq-glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="1.6" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <radialGradient id="giq-core" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#6fec98" />
          <stop offset="100%" stopColor="#22d47a" />
        </radialGradient>
      </defs>
      {/* Rings on a subtle dark disc so the mark reads on both light and dark nav */}
      <g clipPath="url(#giq-clip)">
        <circle cx="32" cy="32" r="28" fill="#0b1014" />
        <circle cx="32" cy="32" r="22" fill="none" stroke="#3fe576" strokeWidth="1.5" opacity="0.45" />
        <circle cx="32" cy="32" r="16" fill="none" stroke="#22d47a" strokeWidth="1.75" opacity="0.75" />
        <circle cx="32" cy="32" r="10" fill="none" stroke="#3fe576" strokeWidth="2" />
        <circle cx="32" cy="32" r="4" fill="url(#giq-core)" filter="url(#giq-glow)" />
      </g>
      {/* Signal line with glow-capped endpoints */}
      <line
        x1="4"
        y1="32"
        x2="60"
        y2="32"
        stroke="#22d47a"
        strokeWidth="1.75"
        strokeLinecap="round"
        opacity="0.75"
      />
      <circle cx="4" cy="32" r="2.25" fill="#22d47a" filter="url(#giq-glow)" />
      <circle cx="60" cy="32" r="2.25" fill="#22d47a" filter="url(#giq-glow)" />
    </svg>
  );
}
